import { NodeShape } from '../../../../../../../api/com/MetaPattern/MDA/Designer/Shape/NodeShape';
import { PartShape } from '../../BaseShape/PartShape';
import { MDAConstant } from '../../Base/MDAConstant';
import { BaseElement } from '../../../../../../../api/com/MetaPattern/MDA/MD/Base/BaseElement';
import { EnumErrorLevel } from '../../../../../../../api/com/MetaPattern/Core/Infrastructure/Common/EnumErrorLevel';
import { ValidationResult } from '../../../../../../../api/com/MetaPattern/Core/Infrastructure/Common/ValidationResult';
import { ValidationResultHelper } from '../../Base/ValidationResultHelper';
import { ValidateHelper } from '../../../../Product/IDE/Util/ValidateHelper';
import { MDShape } from '../../BaseShape/MDShape';
import { MDExtendService } from '../../../MD/MDExtendService';
import { Diagram } from '../Diagram';
import { BEComponent } from '../../../../../../../api/com/MetaPattern/MDA/MD/EntityModel/BEComponent';
import { MethodParameter } from '../../../../../../../api/com/MetaPattern/MDA/MD/EntityModel/MethodParameter';
import { Double2D } from '../../../../../../../api/com/MetaPattern/MDA/Designer/Base/Double2D';
import { EnumPersistenceStatus } from '../../../../../../../api/com/MetaPattern/Core/Infrastructure/Common/EnumPersistenceStatus';
import { EnumDisplayLanguage } from '../../../../../../../api/com/MetaPattern/MDA/Designer/Base/EnumDisplayLanguage';
import { EnumDataType, EnumDataTypeMD } from '../../../../../../../api/com/MetaPattern/Core/Infrastructure/Common/EnumDataType';
import { DataTypeManager } from '../../../MD/DataTypeManager';
import { BEValueObject } from '../../../../../../../api/com/MetaPattern/MDA/MD/EntityModel/BEValueObject';
import { ValueObjectAttribute } from '../../../../../../../api/com/MetaPattern/MDA/MD/EntityModel/ValueObjectAttribute';
import { ValueObjectMethod } from '../../../../../../../api/com/MetaPattern/MDA/MD/EntityModel/ValueObjectMethod';
import { ShapeModel } from '../../BaseShape/ShapeModel';
import { MDValidation } from '../../../MD/MDValidation';
import { MDRepository } from '../../../MD/MDRepository';

export class JointValueObjectShape extends PartShape {
  constructor(attributes?: any, opt?: any) {
    super(attributes, opt);
    // this.id = this.curEntity.designId;
    this.set('type', 'mst.JointValueObjectShape');
    this.attr({
      '.uml-type-icon': { xlinkHref: '/imgs/icons/icon_ValueObject.png' }
    });
    // 反序列化调用，手工创建的时候不调用
    if (attributes) {
      this.setMD(attributes?.shape, attributes?.model.element, true);
    }
  }

  public setMD(elementShape: NodeShape, element: BEValueObject, isFromJSON: boolean) {
    if (element) {
      MDExtendService.setElementListSequence(element.attributes, false);
      MDExtendService.setElementListSequence(element.methods, false);
      element.methods.forEach(method => {
        MDExtendService.setElementListSequence(method.parameters, false);
      });
    }
    this.setBaseMD(elementShape, this.createModel(element, !elementShape.isExpend), isFromJSON);
  }

  public get valueObject(): BEValueObject {
    return this.element() as BEValueObject;
  }

  public shapeType(): string {
    return MDAConstant.Type.ADD_VALUEOBJECT;
  }

  public doAction(action: string, designId?: string): BaseElement | null {
    let element = super.doAction(action, designId);
    switch (action) {
      // 添加属性
      case 'shape:addAttribute':
        element = this.addAttribute();
        break;
      // 添加方法
      case 'shape:addMethod':
        element = this.addMethod();
        break;
      case 'shape:deleteChild':
        element = this.deleteChild(designId);
        break;
      default:
        break;
    }
    this.refresh();
    return element;
  }

  /** 根据链接的类型，设置鼠标的样式 */
  public setLinkType(linkType: string) {
    if (linkType === 'mouselink') {
      this.attr({ '.uml-class-container': { cursor: 'not-allowed' }, '.uml-class-name-text': { cursor: 'not-allowed' } });
    } else {
      this.attr({ '.uml-class-container': { cursor: 'move' }, '.uml-class-name-text': { cursor: 'move' } });
    }
  }

  /**
   * 克隆图形，包括图形内部所有元素，不包括与其他图形的关系
   * @param diagram 克隆后所属的图表
   * @param elements 克隆的所有元数据都插入数组返回
   */
  public cloneShape(diagram: Diagram, elements: Array<BaseElement>): MDShape {
    const jShape = new JointValueObjectShape();

    const valueObjectShape = new NodeShape();
    valueObjectShape.copyFrom(this.shape(), false);
    MDExtendService.setCreateInfo(valueObjectShape);
    valueObjectShape.startPoint = new Double2D(this.position().x + 20, this.position().y + 20);
    valueObjectShape.diagram_ID = diagram.diagramShape.id;
    diagram.diagramShape.nodeShapes.push(valueObjectShape);

    const newValueObject = new BEValueObject();
    newValueObject.copyFrom(this.valueObject, false);
    MDExtendService.setCreateInfo(newValueObject);
    elements.push(newValueObject);
    if (diagram.component instanceof BEComponent) {
      newValueObject.component_ID = diagram.component.id;
      diagram.component.valueObjects.push(newValueObject);
    }

    this.valueObject.attributes.forEach(item => {
      const attribute = new ValueObjectAttribute();
      attribute.copyFrom(item, false);
      MDExtendService.setCreateInfo(attribute);
      attribute.valueObject_ID = newValueObject.id;
      newValueObject.attributes.push(attribute);
      elements.push(attribute);
    });

    this.valueObject.methods.forEach(item => {
      const method = new ValueObjectMethod();
      method.copyFrom(item, false);
      MDExtendService.setCreateInfo(method);
      method.valueObject_ID = newValueObject.id;
      newValueObject.methods.push(method);
      elements.push(method);
      item.parameters.forEach(parameter => {
        const newParameter = new MethodParameter();
        newParameter.copyFrom(parameter, false);
        MDExtendService.setCreateInfo(newParameter);
        newParameter.entityMethod_ID = method.id;
        method.parameters.push(newParameter);
        elements.push(newParameter);
      });
    });

    valueObjectShape.elementId = newValueObject.designId;
    jShape.setMD(valueObjectShape, newValueObject, false);
    diagram.cells.push(jShape);
    return jShape;
  }

  public addChildClone(element: BaseElement, elements: Array<BaseElement>): ValueObjectAttribute | ValueObjectMethod | null {
    let newElement: ValueObjectAttribute | ValueObjectMethod | null = null;
    if (element instanceof ValueObjectAttribute) {
      newElement = new ValueObjectAttribute();
      newElement.copyFrom(element, false);
      MDExtendService.setCreateInfo(newElement);
      newElement.valueObject_ID = this.valueObject.id;
      this.valueObject.attributes.push(newElement);
      this.model().compartments[0].push(newElement);
      elements.push(newElement);
    } else if (element instanceof ValueObjectMethod) {
      newElement = new ValueObjectMethod();
      newElement.copyFrom(element, false);
      MDExtendService.setCreateInfo(newElement);
      newElement.valueObject_ID = this.valueObject.id;
      this.valueObject.methods.push(newElement);
      this.model().compartments[1].push(newElement);
      elements.push(newElement);
      element.parameters.forEach(parameter => {
        const newParameter = new MethodParameter();
        newParameter.copyFrom(parameter, false);
        MDExtendService.setCreateInfo(newParameter);
        newParameter.entityMethod_ID = newElement.id;
        (newElement as ValueObjectMethod).parameters.push(newParameter);
        elements.push(newParameter);
      });
    }
    return newElement;
  }

  protected getDisplayTitle(element: BaseElement) {
    let title = element.displayName;
    if (element instanceof ValueObjectAttribute) {
      if (this.displayLanguage === EnumDisplayLanguage.English) {
        title = `${element.name}:${this.getDataType(element.dataType, element.referenceType)}`;
      } else {
        title = `${element.displayName}:${this.getDataType(element.dataType, element.referenceType)}`;
      }
    } else if (element instanceof ValueObjectMethod) {
      if (this.displayLanguage === EnumDisplayLanguage.English) {
        title = `${element.name}:${this.getDataType(element.returnDataType, element.returnReferenceType)}`;
      } else {
        title = `${element.displayName}:${this.getDataType(element.returnDataType, element.returnReferenceType)}`;
      }
    } else {
      if (this.displayLanguage === EnumDisplayLanguage.English) {
        title = element.name;
      } else {
        title = element.displayName;
      }
    }
    return title;
  }

  private addAttribute(): ValueObjectAttribute {
    const attribute = MDRepository.createValueObjectAttribute(this.valueObject);
    MDExtendService.setElementListSequence(this.valueObject.attributes, true);
    this.model().compartments[0].push(attribute);
    return attribute;
  }

  private addMethod(): ValueObjectMethod {
    const method = MDRepository.createValueObjectMethod(this.valueObject);
    MDExtendService.setElementListSequence(this.valueObject.methods, true);
    this.model().compartments[1].push(method);
    return method;
  }

  /** 删除子元素及对应的行 */
  private deleteChild(designId: string): BaseElement | null {
    console.log('deleteChild');
    let element: BaseElement = null;
    element = this.valueObject.attributes.find(item => item.designId === designId);
    if (!element) {
      element = this.valueObject.methods.find(item => item.designId === designId);
    }
    if (element) {
      // 新建状态的，需要从元数据中删除
      if (element.persistenceStatus === EnumPersistenceStatus.Create) {
        if (element instanceof ValueObjectAttribute) {
          this.valueObject.attributes.splice(this.valueObject.attributes.findIndex(item => item.designId === element.designId), 1);
        } else if (element instanceof ValueObjectMethod) {
          this.valueObject.methods.splice(this.valueObject.methods.findIndex(item => item.designId === element.designId), 1);
        }
      } else {
        element.persistenceStatus = EnumPersistenceStatus.Delete;
      }
      return this.deleteRow(designId);
    }
    return null;
  }

  /** 设置图形的Model */
  private createModel(valueObject: BEValueObject, isCollapse = false): ShapeModel {
    const model = new ShapeModel(valueObject, isCollapse);
    model.addCompartment(valueObject.attributes.filter(item => item.persistenceStatus !== EnumPersistenceStatus.Delete));
    model.addCompartment(valueObject.methods.filter(item => item.persistenceStatus !== EnumPersistenceStatus.Delete));
    return model;
  }

  /**
   * 校验模型
   * 1. 值对象
   * 2. 属性
   *    - 必须选择引用数据类型
   *    - 特定数据类型（数值、布尔）及枚举不能为空
   *    - 不能存在同名属性
   * 3. 方法
   *    - 必须选择返回值引用数据类型
   *    - 不能存在同名方法
   *    - 参数必须选择引用数据类型
   *    - 方法内不能存在同名参数
   */
  public validate(): Array<ValidationResult> {
    const errors = super.validate();
    const containerDesignId = this.valueObject.designId;
    MDValidation.validateBaseElement(this.valueObject, containerDesignId, true, errors);
    this.valueObject.attributes.forEach((element) => {
      MDValidation.validateBaseElement(element, containerDesignId, true, errors);
      if ((element.dataType === EnumDataType.Reference || element.dataType === EnumDataType.UniqueKey) && !ValidateHelper.IsNotNullOrEmpty(element.referenceType)) {
        errors.push(ValidationResultHelper.createResult(EnumErrorLevel.Error, containerDesignId, element.designId, `值对象 [${this.valueObject.displayName}] 的属性 [${element.displayName}] 必须选择引用数据类型`));
      }
      if ((!DataTypeManager.instance.isNullable(element.dataType) || ValidateHelper.IsEnum(element.dataType, element.referenceType)) && element.isNullable) {
        errors.push(ValidationResultHelper.createResult(EnumErrorLevel.Error, containerDesignId, element.designId, `值对象 [${this.valueObject.displayName}] 的属性 [${element.displayName}] 不能为空`));
      }
      if (this.valueObject.attributes.find(item => element.designId !== item.designId && element.name === item.name)) {
        errors.push(ValidationResultHelper.createResult(EnumErrorLevel.Error, containerDesignId, element.designId, `值对象 [${this.valueObject.displayName}] 不能存在同名属性 [${element.name}]`));
      }
    });

    this.valueObject.methods.forEach((element) => {
      MDValidation.validateBaseElement(element, containerDesignId, true, errors);
      if ((element.returnDataType === EnumDataType.Reference || element.returnDataType === EnumDataType.UniqueKey) && !ValidateHelper.IsNotNullOrEmpty(element.returnReferenceType)) {
        errors.push(ValidationResultHelper.createResult(EnumErrorLevel.Error, containerDesignId, element.designId, `值对象 [${this.valueObject.displayName}] 的方法 [${element.displayName}] 必须选择返回值引用数据类型`));
      }
      if (this.valueObject.methods.find(item => element.designId !== item.designId && element.name === item.name)) {
        errors.push(ValidationResultHelper.createResult(EnumErrorLevel.Error, containerDesignId, element.designId, `值对象 [${this.valueObject.displayName}] 不能存在同名方法 [${element.name}]`));
      }
      element.parameters.forEach((parameter) => {
        MDValidation.validateBaseElement(parameter, containerDesignId, false, errors);
        if ((parameter.dataType === EnumDataType.Reference || parameter.dataType === EnumDataType.UniqueKey) && !ValidateHelper.IsNotNullOrEmpty(parameter.referenceType)) {
          errors.push(ValidationResultHelper.createResult(EnumErrorLevel.Error, containerDesignId, parameter.designId, `值对象 [${this.valueObject.displayName}] 方法 [${element.displayName}] 的参数 [${parameter.displayName}] 必须选择引用数据类型`));
        }
        if (element.parameters.find(item => parameter.designId !== item.designId && parameter.name === item.name)) {
          errors.push(ValidationResultHelper.createResult(EnumErrorLevel.Error, containerDesignId, parameter.designId, `值对象 [${this.valueObject.displayName}] 方法 [${element.displayName}] 不能存在同名参数 [${parameter.name}]`));
        }
      });
    });
    return errors;
  }
}
